// Per-project branding configuration shown in the hosted auth-ui.
// Mirrors apps/api/app/models/project.rb's BRANDING_COLOR_KEYS list and
// BRANDING_LAYOUTS/BRANDING_THEMES.

export const BRANDING_COLOR_KEYS = [
  'primary_color',
  'primary_hover_color',
  'accent_color',
  'background_color',
  'foreground_color',
  'error_color',
] as const;

export type BrandingColorKey = (typeof BRANDING_COLOR_KEYS)[number];

export type BrandingColors = Record<BrandingColorKey, string | null>;

export const BRANDING_LAYOUTS = ['centered', 'split'] as const;
export type BrandingLayout = (typeof BRANDING_LAYOUTS)[number];

export const BRANDING_THEMES = ['light', 'dark', 'auto'] as const;
export type BrandingTheme = (typeof BRANDING_THEMES)[number];

export interface ProjectBranding {
  app_name: string | null;
  resolved_app_name: string;
  logo_url: string | null;
  colors: BrandingColors;
  colors_dark: BrandingColors;
  layout: BrandingLayout;
  default_theme: BrandingTheme;
  allow_user_theme_override: boolean;
  color_keys: BrandingColorKey[];
  available_layouts: BrandingLayout[];
  available_themes: BrandingTheme[];
  max_app_name_length: number;
}

export interface ProjectBrandingResponse {
  success: boolean;
  data: ProjectBranding;
  message?: string;
  error?: string;
  details?: string[];
}

export type ProjectBrandingUpdate = Partial<BrandingColors> & {
  app_name?: string | null;
  layout?: BrandingLayout;
  default_theme?: BrandingTheme;
  allow_user_theme_override?: boolean;
  colors_dark?: Partial<BrandingColors>;
};

// Hex color: #RGB or #RRGGBB. Mirrors backend BRANDING_COLOR_FORMAT.
export const HEX_COLOR_REGEX = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

export function isValidHexColor(value: string): boolean {
  return HEX_COLOR_REGEX.test(value);
}
